import '../../css/App.css'
import '../../css/PageTemplate.css'
import '../../css/ViewEditAsset.css'
import React, { useContext, useEffect } from 'react';
import { IAuth, IConfiguration, IViewEditForm, IViewEditFormValidation } from '../../interfaces/interface';
import { IMessageSender, IMessageErrorResponse } from '../../interfaces/messageInterface';
import { AppContext } from '../context/AppContext';
import HeaderTemplate from '../HeaderTemplate';
import ViewEditAssetForm from './ViewEditAssetForm';
import PopMessage from '../PopMessage/PopMessage';
import { ViewEditAssetContext } from '../context/ViewEditAssetContext';
import axios from 'axios';

function ViewEditAsset() {
  const { navBarStatus, config, authorization, disMessage, navBarHandler, errorHandlerFunction } = useContext(AppContext);
  const { form, formEdit, errMessage, newIdAssetInfo, fieldEnable } = useContext(ViewEditAssetContext); 
  const [ auth ]: IAuth[] = authorization;
  const [isNavbarOpen] = navBarStatus;
  const navBarClickHandler: (e: any) => void = navBarHandler
  const [displayMessage]: string[] = disMessage;
  const [configuration] :IConfiguration[] = config
  const [,setConfiguration] :React.Dispatch<React.SetStateAction<IConfiguration>>[] = config
  const [formInput]: IViewEditForm[] = form;     
  const [formInputEdit]: IViewEditForm[] = formEdit;
  const [,setFormInputEdit]: React.Dispatch<React.SetStateAction<IViewEditForm>>[] = formEdit;     
  const [,setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;
  const [assetInfoOfNewId] = newIdAssetInfo;
  const [isFieldEnable,setIsFieldEnable] = fieldEnable;
  const [errorMessage]:string[] = errMessage;
  const [,setErrorMessage]: React.Dispatch<React.SetStateAction<string>>[] = errMessage;
  const errorHandler: (status: number) => string = errorHandlerFunction; 

  useEffect(() => {
    setDisplayMessage("none")
   },[])
   
  const viewEditAssetHandler = () => {
    let messageBody:IMessageSender  = {
      type: 'updateAsset',
      userId: auth.username,
      assetInfo: formInputEdit
    }
    setDisplayMessage("processing");
    axios.post('/message',messageBody, auth.header
    ).then(res => {
      if(res.data.status === "OK"){
        setDisplayMessage("done");
      }else{
        setErrorMessage(res.data.errorDescription)
        setDisplayMessage("error");
      }
    }).catch(({response}:IMessageErrorResponse) => {
      const errorMessage = errorHandler(response.data.status)
      setErrorMessage(errorMessage)
      setDisplayMessage("error");
    })
    if(!configuration.assetTypes.includes(formInput.assetType)){
      setConfiguration({
      ...configuration,
      assetTypes: [...configuration.assetTypes, formInput.assetType]
    })

    }
  }
  const deviceIdReplaceHandler = (e :any):void => {
    if(e.target.id === "confirm-button"){
      let messageBody:IMessageSender  = {
        type: 'detachAsset',
        userId: auth.username,
        assetInfo: {...assetInfoOfNewId}
      }      
      setDisplayMessage("processing");
      axios.post('/message',messageBody, auth.header
      ).then(res => {
        if(res.data.status === "OK"){
          setDisplayMessage("deviceId-reassigned");
          setTimeout(() => {
            setDisplayMessage("none")
          },1000)
        }else{
          setErrorMessage(res.data.errorDescription)
          setDisplayMessage("error");
          setIsFieldEnable({
            ...isFieldEnable,
            deviceId: {field :false, edit: false},
          })
          setFormInputEdit({
            ...formInputEdit,
            deviceId: formInput.deviceId
          })
        }
      }).catch(({response}:IMessageErrorResponse) => {
        const errorMessage = errorHandler(response.data.status)
        setErrorMessage(errorMessage)
        setDisplayMessage("error");
      })
    }else{
      setIsFieldEnable({
        ...isFieldEnable,
        deviceId: {field :false, edit: false},
      })
      setFormInputEdit({
        ...formInputEdit,
        deviceId: formInput.deviceId
      })
      setDisplayMessage("none");
    }
  }
  return (
      <div className='page-template ViewEditAsset' onClick={navBarClickHandler}>
          <HeaderTemplate title="View / Edit Asset" />
        <div className={(displayMessage !== "none" || isNavbarOpen === true)?'page-template-main blur': 'page-template-main'} onClick={navBarClickHandler}>
          <ViewEditAssetForm />
        </div>
        {displayMessage !== "none" && 
          <div className='page-template-pop-message'>
            <PopMessage 
              assetHandler={viewEditAssetHandler}
              formData={formInputEdit}
              type={"general"}
              error={errorMessage}
              assetInfoOfNewId={assetInfoOfNewId}
              deviceIdReplaceHandler={deviceIdReplaceHandler}
            />
          </div>
          }
    </div>
  );
}

export default ViewEditAsset;

